module.exports = __webpack_public_path__ + "img/qiti.00baca4b.svg";